export function isNotNull<T> (input: T | null): input is T {
  return input !== null;
}
